import {EventIdResponseInterface} from "../../interfaces/event.interface";

export const eventInitialState: EventIdResponseInterface = {
    requestState: 'IDLE',
    data: undefined
}
